import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DnAnimationDirective } from './dn-animation.directive';

@NgModule({
  declarations: [DnAnimationDirective],
  imports: [CommonModule],
  exports: [DnAnimationDirective],
})
export class DnAnimationModule {}
